import $ from 'jquery';

function shouldUpdateContent(issuer) {
  return issuer && issuer.toLowerCase().indexOf('torii') > -1;
}

function updatePortalContent(issuer) {
  if (shouldUpdateContent(issuer)) {
    addPreviewOption();
    updatePortalText();
  }
}

function addPreviewOption() {
  var $options = $('.okta-dropdown-option');
  var $preview = '<option value="oktapreview.com">oktapreview.com</option>';
  $options.empty();
  $options.prepend($preview);
}

function updatePortalText() {
  var $title = $('.signin-title');
  var $header = $('.signin-head');
  var $footer = $('.signin-footer');
  var $go = $('.go-btn');
  $title.html('Sign in as an Okta administrator');
  $header.remove();
  $footer.remove();
  $title.after('<p class="okta-form-footer okta-form-subtitle torii-subtitle torii-subtitle-e2e">' +
      'Enter the org subdomain where you are an administrator. ex: ' +
      '<strong>dev-123</strong>.oktapreview.com or <strong>company</strong>.oktapreview.com</p>');
  $go.after('<div>' +
      '<p class="torii-helper-footer">Don\'t have an org? <a href="https://www.okta.com/developer/signup/">' +
      'Sign-up</a> for a free org</p>' +
      '<p class="torii-helper-footer">Contact ' +
      '<a href="mailto:developers@okta.com">developers@okta.com</a> for support</p>' +
      '</div>');
}

export default {
  shouldUpdateContent,
  updatePortalContent
};



// WEBPACK FOOTER //
// ./lib/custom-content-util.js